<template>
  <div class="p-0">
    to aqui
    <h6 class="text-two">
      {{ question.semiology_form_question_type_description }}
    </h6>
    <div
      class="form-check"
      v-for="(item, key) in question.alternatives"
      :key="key"
    >
      <input
        :disabled="question.answered || !linked_profile_id_can_answer"
        :checked="item.answer"
        class="form-check-input"
        type="radio"
        :name="question.id"
        :id="`rating-${item.id}`"
        :value="item.id"
        @input="emit($event.target.value)"
      />
      <label :for="`rating-${item.id}`" class="form-check-label">
        {{ key + 1 }} - {{ item.label }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "Question",

  props: {
    linked_profile_id_can_answer: {
      type: Boolean,
      default: true,
    },

    category_id: [String, Number],
    question: Object,
  },

  methods: {
    emit(answer) {
      this.$emit("answer", {
        category_id: this.category_id,
        id: this.question.id,
        answer,
      });
    },
  },
};
</script>
